import { jwtDecode } from 'jwt-decode';
import axios from '@axios';
import { getAccessToken } from '@/services/SessionService';

const base = '/api/v1/';

export function convertMdmToken(token) {
  const authHeader = /^Bearer\s/i.test(token) ? token : `Bearer ${token}`;
  return axios.post(`${base}mdm-users/tokens`, null, {
    headers: {
      Authorization: authHeader,
    },
    skipAuthHeader: true,
    skipAuthRefresh: true,
  });
}

export function getToken() {
  return getAccessToken();
}

export function getTokenPayload() {
  const token = getToken();
  if (!token) return null;
  try {
    return jwtDecode(token);
  } catch (e) {
    console.error('Failed to decode JWT', e);
    return null;
  }
}

export function getUserId() {
  return getTokenPayload()?.prisoner_number ?? null;
}
